import * as url from "helpers/url_helper/url_helper"
import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"

export const getApplicationStatusDef = () => get(url.GET_APPLICATION_STATUS_DEF)